import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const dict = {
    en: {
        _name: "English", _flag: "🇬🇧",
        "nav.atRisk": "At-Risk Dogs", "nav.dogs": "Dogs", "nav.rescues": "Rescues",
        "nav.shelters": "Shelters", "nav.services": "Services", "nav.aiMatch": "AI Match",
        "nav.community": "Community", "nav.transport": "Transport", "nav.donate": "Donate",
        "nav.signin": "Sign in",
        "hero.eyebrow": "A global rescue network",
        "hero.line1": "No dog runs",
        "hero.line2": "out of time",
        "hero.line3": "alone.",
        "hero.body": "From Seoul to Bali to Houston — RescueLink connects shelters, rescues, fosters, and adopters across 17+ countries into one living network.",
        "hero.cta1": "See dogs at risk",
        "hero.cta2": "Find your match",
        "stat.atRiskNow": "At Risk Now",
        "stat.dogsListed": "Dogs Listed",
        "stat.countries": "Countries",
        "stat.rescuePartners": "Rescue Partners",
    },
    ko: {
        _name: "한국어", _flag: "🇰🇷",
        "nav.atRisk": "위험한 개들", "nav.dogs": "개", "nav.rescues": "구조",
        "nav.shelters": "보호소", "nav.services": "서비스", "nav.aiMatch": "AI 매치",
        "nav.community": "커뮤니티", "nav.transport": "이동", "nav.donate": "기부",
        "nav.signin": "로그인",
        "hero.eyebrow": "글로벌 구조 네트워크",
        "hero.line1": "어떤 개도",
        "hero.line2": "시간이 다 되도록",
        "hero.line3": "혼자 두지 않습니다.",
        "hero.body": "서울에서 발리, 휴스턴까지 — RescueLink는 17개국 이상의 보호소, 구조 단체, 임시보호자, 입양자를 하나의 살아있는 네트워크로 연결합니다.",
        "hero.cta1": "위험한 개 보기",
        "hero.cta2": "나의 짝 찾기",
        "stat.atRiskNow": "현재 위험",
        "stat.dogsListed": "등록된 개",
        "stat.countries": "국가",
        "stat.rescuePartners": "구조 파트너",
    },
    ja: {
        _name: "日本語", _flag: "🇯🇵",
        "nav.atRisk": "危険な犬", "nav.dogs": "犬", "nav.rescues": "レスキュー",
        "nav.shelters": "シェルター", "nav.services": "サービス", "nav.aiMatch": "AIマッチ",
        "nav.community": "コミュニティ", "nav.transport": "輸送", "nav.donate": "寄付",
        "nav.signin": "サインイン",
        "hero.eyebrow": "グローバル・レスキュー・ネットワーク",
        "hero.line1": "どの犬も",
        "hero.line2": "時間切れで",
        "hero.line3": "独りにしません。",
        "hero.body": "ソウルからバリ、ヒューストンまで—RescueLinkは17か国以上のシェルター、レスキュー、里親、養子縁組者を一つの生きたネットワークで繋ぎます。",
        "hero.cta1": "危険な犬を見る",
        "hero.cta2": "マッチを見つける",
        "stat.atRiskNow": "現在危険",
        "stat.dogsListed": "登録犬",
        "stat.countries": "国",
        "stat.rescuePartners": "レスキューパートナー",
    },
    th: {
        _name: "ไทย", _flag: "🇹🇭",
        "nav.atRisk": "สุนัขเสี่ยง", "nav.dogs": "สุนัข", "nav.rescues": "หน่วยกู้ภัย",
        "nav.shelters": "สถานสงเคราะห์", "nav.services": "บริการ", "nav.aiMatch": "AI จับคู่",
        "nav.community": "ชุมชน", "nav.transport": "ขนส่ง", "nav.donate": "บริจาค",
        "nav.signin": "เข้าสู่ระบบ",
        "hero.eyebrow": "เครือข่ายกู้ภัยระดับโลก",
        "hero.line1": "ไม่มีสุนัขตัวไหน",
        "hero.line2": "หมดเวลา",
        "hero.line3": "อย่างโดดเดี่ยว",
        "hero.body": "จากโซลถึงบาหลีถึงฮูสตัน — RescueLink เชื่อมสถานสงเคราะห์ หน่วยกู้ภัย ผู้ดูแลชั่วคราว และผู้รับเลี้ยงกว่า 17 ประเทศให้เป็นเครือข่ายเดียว",
        "hero.cta1": "ดูสุนัขที่เสี่ยง",
        "hero.cta2": "หาคู่ที่ใช่",
        "stat.atRiskNow": "เสี่ยงตอนนี้",
        "stat.dogsListed": "สุนัขทั้งหมด",
        "stat.countries": "ประเทศ",
        "stat.rescuePartners": "พันธมิตร",
    },
    hi: {
        _name: "हिन्दी", _flag: "🇮🇳",
        "nav.atRisk": "जोखिम में", "nav.dogs": "कुत्ते", "nav.rescues": "बचाव",
        "nav.shelters": "शरण", "nav.services": "सेवाएँ", "nav.aiMatch": "एआई मैच",
        "nav.community": "समुदाय", "nav.transport": "परिवहन", "nav.donate": "दान",
        "nav.signin": "साइन इन",
        "hero.eyebrow": "एक वैश्विक बचाव नेटवर्क",
        "hero.line1": "कोई भी कुत्ता",
        "hero.line2": "अकेला",
        "hero.line3": "समय से बाहर न हो।",
        "hero.body": "सियोल से बाली से ह्यूस्टन तक — RescueLink 17+ देशों में शरणस्थलों, बचाव समूहों, फोस्टर और गोद लेने वालों को एक जीवित नेटवर्क में जोड़ता है।",
        "hero.cta1": "जोखिम वाले कुत्ते देखें",
        "hero.cta2": "अपना मैच खोजें",
        "stat.atRiskNow": "अभी जोखिम में",
        "stat.dogsListed": "सूचीबद्ध कुत्ते",
        "stat.countries": "देश",
        "stat.rescuePartners": "बचाव भागीदार",
    },
    id: {
        _name: "Bahasa", _flag: "🇮🇩",
        "nav.atRisk": "Anjing Berisiko", "nav.dogs": "Anjing", "nav.rescues": "Penyelamatan",
        "nav.shelters": "Penampungan", "nav.services": "Layanan", "nav.aiMatch": "Cocokkan AI",
        "nav.community": "Komunitas", "nav.transport": "Transportasi", "nav.donate": "Donasi",
        "nav.signin": "Masuk",
        "hero.eyebrow": "Jaringan penyelamatan global",
        "hero.line1": "Tidak ada anjing",
        "hero.line2": "kehabisan waktu",
        "hero.line3": "sendirian.",
        "hero.body": "Dari Seoul, Bali, hingga Houston — RescueLink menghubungkan penampungan, penyelamat, foster, dan pengadopsi di 17+ negara menjadi satu jaringan hidup.",
        "hero.cta1": "Lihat anjing berisiko",
        "hero.cta2": "Temukan pasanganmu",
        "stat.atRiskNow": "Berisiko sekarang",
        "stat.dogsListed": "Anjing terdaftar",
        "stat.countries": "Negara",
        "stat.rescuePartners": "Mitra penyelamatan",
    },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
    const [lang, setLang] = useState(() => localStorage.getItem("rl_lang") || "en");
    useEffect(() => { localStorage.setItem("rl_lang", lang); }, [lang]);
    const t = useCallback((key) => (dict[lang] && dict[lang][key]) || dict.en[key] || key, [lang]);
    const languages = Object.keys(dict).map((code) => ({ code, name: dict[code]._name, flag: dict[code]._flag }));
    return (
        <I18nContext.Provider value={{ lang, setLang, t, languages }}>
            {children}
        </I18nContext.Provider>
    );
}

export const useI18n = () => useContext(I18nContext);
